import { FaEthereum } from "react-icons/fa";

const logotext = "Suhasmashetty";
const meta = {
    title: "Suhas",
    description: "I’m Suhas  Full stack developer,currently CSE undergrad",
};

const introdata = {
    title: "I’m Suhas",
    animated: {
        first: "I love coding",
        second: "I build websites",
        third: "I love playing FPS games"
    },
    description: "Hii i am a Web Dev and  Web3 Dev #{Solana,Ethereum}, Valorant Esports player (rank: Immortal) ",
    your_img_url: "https://images.unsplash.com/photo-1470790376778-a9fbc86d70e2?q=80&w=2008&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
};

const dataabout = {
    title: "abit about my self",
    aboutme: "I'm suhas, a 20 year old devloper and a gamer. I am aself taught developer.In my free time i play fps games like Valorant and CS:GO. I have intrest in web3and blockchain technology and currently messing with Solana and Ethereum.",
};

const Waddress = {
    bitcoin: "bc1qrpdmvghq6p0tr6ufd45m4tu44renqlle3p6xat",
    solana: "GE3v86q7SLWy7Z7VCSqrRUbZXVMYiYqo7uxper5ZXvS6",
    ethereum:"0x2EEaA0344F87953F5e913C62F93c9F3254cf9f18"
}

const skills = [
  { name: "JavaScrpt", icon: "fab fa-js" },
  { name: "React", icon: "fab fa-react"},
  { name: "TypeScript", icon: "si si-typescript" }, 
  { name: "HTML", icon: "fab fa-html5" },
  { name: "C", icon: "custom-icons/c-icon.svg" },
  { name: "Java", icon: "fab fa-java" },
  { name: "MongoDB", icon: "custom-icons/mongodb.svg" },
  { name: "PostgreSQL", icon: "custom-icons/postgres.svg" },
  { name: "Nginx", icon: "custom-icons/nginx.svg" },
  { name: "Prisma", icon: "custom-icons/prisma.svg" },
  { name: "Docker", icon: "fab fa-docker" },
  { name: "Kubernetes", icon: "custom-icons/kubernetes.svg" },
  { name: "Tailwind", icon: "fab fa-tailwind"},
  { name: "Rust", icon: "fab fa-rust" },
  { name: "Anchor", icon : "custom-icons/anchor.svg" },
  { name: "Solidity", icon: "custom-icons/solidity.svg" },
  { name: "Solana", icon: "custom-icons/solana.svg" },
];


const datablogs = [
  {
    img: process.env.PUBLIC_URL + "/assets/blogImages/nginx.png",
    title: "How NGINX Works",
    date: "Jan 25, 2025",
    readTime: "2 min read",
    description: "Learn how NGINX handles reverse proxying, load balancing, and how it fits into modern backend infrastructure.",
    tags: ["nginx", "backend", "devops"],
    link: "/blogs/0"
  },
   {
    img: process.env.PUBLIC_URL + "/assets/blogImages/bridge.jpeg",
    title: "Understanding Blockchain Bridges",
    date: "June 10, 2025",
    readTime: "3 min read",
    description:
      "Learn the basics of blockchain bridges, why they’re needed, and how they connect different networks like Ethereum, BNB Chain, and Solana.",
    content:
      "Blockchain bridges are protocols that allow users to transfer assets or data between different blockchain networks. These bridges solve the problem of interoperability by 'wrapping' tokens, ensuring they can exist and be transacted across chains. For example, a bridge might let you use your ETH on the BNB Chain or transfer USDT from Avalanche to Base. There are two main types: trusted bridges (run by centralized entities) and trustless bridges (run by smart contracts). Each has trade-offs in terms of speed, security, and decentralization.",
    tags: ["blockchain", "bridges", "interoperability"],
    link: "/blogs/1"
  },
  {
    img: process.env.PUBLIC_URL + "/assets/blogImages/solana.webp",
    title: "Understanding how Transaction creation and validation works in solana",
    date: "July 8, 2025",
    readTime: "5 min read",
    description: "Solana is a high-performance blockchain designed for speed and efficiency allowing developers to create decentralized applications(dApps) and users to transact with hogh speed.",
    tags: ["solana", "blockchain", "web3"],
    link: "/blogs/2"
  },
  {
    img: process.env.PUBLIC_URL + "/assets/blogImages/rust.png",
    title: "Booststrap: Getting Started with Rust on Solana",
    date: "July 8, 2025",
    readTime: "5 min read",
    description:
      "Explore how to get started with Rust programming on the Solana blockchain, including setting up your environment and writing your first smart contract.",
    tags: ["solana", "rust", "web3", "smart contracts"],
    link: "/blogs/3"
  },
  {
    img: process.env.PUBLIC_URL + "/assets/blogImages/Rust.webp",
    title: "Rust Learnings",
    date: "July 18, 2025",
    readTime: "4 min read",
    description: "Rust concepts, tips, and resources for developers looking to master this powerful language.",
    tags: ["rust", "programming", "web3"],
    link: "/blogs/4"
  }

];

const dataportfolio = [
  {
    img: "/assets/projectImages/solanadapp.png",
    title: "Solana DApp",
    description: "A decentralized app to connect your wallet, make transactions, and perform airdrops.",
    link: "https://solanadapppp.vercel.app/",
    tags: ["Solana", "Web3", "DApp"]
  },
  {
    img: "/assets/projectImages/tokenLP.png",
    title: "Token Launchpad",
    description: "A crypto kickstarter platform to launch your own coin. (More features coming soon.)",
    link: "https://token-launchpadxyz.vercel.app/",
    tags: ["Blockchain", "Launchpad", "React"]
  },
  {
    img: "/assets/projectImages/walletadap.png",
    title: "Wallet Generator",
    description: "Generates mnemonic seed phrases, public and private keys for Solana and Ethereum wallets.",
    link: "https://web-walllet.vercel.app/",
    tags: ["Solana", "Ethereum", "Wallet", "Crypto"]
  },
  {
    img: "/assets/projectImages/bluberry.png",
    title: "BlueBerry Finance",
    description: "Staking of usdc",
    link: "https://blueberryfi.vercel.app/",
    tags: ["React", "TailwindCSS","solana","Anchor","Rust"]
  },
  {
    img: "/assets/projectImages/Stayin.png",
    title: "StayIN Landing Page",
    description: "Landing Page with login Support",
    link: "https://stay-in-virid.vercel.app/",
    tags: ["React", "TailwindCSS"]
  },
];

const dataweb3 = [
  {
    title: "Vault",
    link: "https://github.com/Suhasmashetti/Vault",
    updated: "4 days ago",
    author: "Suhasmashetti"
  },
  {
    title: "Voting",
    link: "https://github.com/Suhasmashetti/Voting",
    updated: "2 months ago",
    author: "Suhasmashetti"
  },
  {
    title: "Esports Prediction",
    link: "https://github.com/Suhasmashetti/valorant_prediction_market",
    updated: "1 week ago",
    author: "Suhasmashetti"
  },
  {
    title: "Bridge",
    link: "https://github.com/Suhasmashetti/bridge-ETH-base",
    updated: "9 days ago",
    author: "Suhasmashetti"
  },
  {
    title: "pumpfun Token fetcher using yellow stone gRPC",
    link: "https://github.com/Suhasmashetti/Yellowstone-grpc/tree/main/solana-grpc",
    updated: "1 week ago",
    author: "Suhasmashetti"
  },
    {
    title: "InfraScan",
    link: "https://github.com/Suhasmashetti/infrascan",
    updated: "1 week ago",
    author: "Suhasmashetti"
  },
{
    title: "sol-Staking",
    link: "https://github.com/Suhasmashetti/sol_staking",
    updated: "1 week ago",
    author: "Suhasmashetti"
  }
];




const contactConfig = {
  YOUR_EMAIL: process.env.REACT_APP_YOUR_EMAIL,
  YOUR_FONE: process.env.REACT_APP_YOUR_FONE,
  description: process.env.REACT_APP_CONTACT_DESCRIPTION,
  YOUR_SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  YOUR_TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  YOUR_USER_ID: process.env.REACT_APP_EMAILJS_USER_ID,
};


const socialprofils = {
    github: "https://github.com/Suhasmashetti",
    twitter: "https://x.com/touchgrassplss",
};
export {
    meta,
    dataabout,
    Waddress,
    datablogs,
    dataportfolio,
    dataweb3,
    skills,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};